import { isBuild } from '@/const/host';

let comeinUrl;
let fileViewerUrl;
let mobileUrl;
let irmMobileUrl;

// 环境区分
if (isBuild) {
	comeinUrl = 'https://server.comein.cn/comein';
	fileViewerUrl = 'https://file-view.comein.cn/onlinePreview?url=';
	mobileUrl = 'https://mobile.comein.cn/mobile';
	irmMobileUrl = 'https://mobile.comein.cn/irm-mobile';
} else {
	comeinUrl = 'https://testserver.comein.cn/comein';
	fileViewerUrl = 'https://file-view-test.comein.cn/onlinePreview?url=';
	mobileUrl = 'https://testmobile.comein.cn/mobile';
	irmMobileUrl = 'https://testmobile.comein.cn/irm-mobile';
}

export const COMEIN_URL = comeinUrl;
export const FILE_VIEWER_URL = fileViewerUrl;
export const MOBILE_URL = mobileUrl;
export const IRM_MOBILE_URL = irmMobileUrl;
